<template>
	<div class="home-index">
		<div class="header">
			<div class="left">
				常德营商地图
			</div>
			<div class="right">
				<span v-html="datetime.nowTime"></span>
			</div>
		</div>
		<div class="main">
			<div class="banner">
				<vue3VideoPlay v-bind="videoOptions" poster="https://vod.changde.gov.cn/vod2/h5/videopic.jpg" />
			</div>
			<div class="overview">
				<div class="list">
					<el-row :gutter="15">
						<el-col :span="6">
							<div class="btn-icon" @click="toUrl('overView')">
								<img src="../assets/images/icon_01.png" width="50" />
								<div>
									常德概况
								</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="btn-icon" @click="toUrl('investInfo')">
								<img src="../assets/images/icon_02.png" width="50" />
								<div>
									投资常德
								</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="btn-icon" @click="toUrl('doingBusiness')">
								<img src="../assets/images/icon_03.png" width="50" />
								<div>
									营商总览
								</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="btn-icon" @click="toArticleList(1)">
								<img src="../assets/images/icon_05.png" width="50" />
								<div>
									发展规划
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="notice">
				<div class="icon">
					<img src="../assets/images/notice_icon.png">
				</div>
				<div class="list">
					<vue3-seamless-scroll :list="dataList" :copyNum="0" :singleLine="true" :singleHeight="40"
						:singleWaitTime="3000" class="scroll">
						<div class="item" v-for="(item, index) in dataList" :key="index"
							@click="toDynamicDetail(item.investmentInformationId)" :style="{width:scrollWith}">
							<div class="title">{{ item.investmentInformationTitle }}</div>
							<div class="date">{{ item.investmentInformationPublishTime.substring(5,10) }}</div>
						</div>
					</vue3-seamless-scroll>
				</div>
				<div class="more" @click="toUrl('dynamicList')">
					<el-icon color="#086ef5" :size="25">
						<ArrowRightBold />
					</el-icon>
				</div>
			</div>
			<div class="links">
				<a href="https://www.changde.gov.cn/cdzcfw/"><img src="../assets/images/zszcjsq.jpg" /></a>
			</div>
			<div class="carrier">
				<div class="carrier-box">
					<div class="carrier-item" style="background: #e0f0fd;" @click="toUrl('parkList')">
						<div class="carrier-item-name">重点<br />园区</div>
						<div class="carrier-item-icon">
							<img style="width: 30px;" src="../assets/images/zdyq.png" />
						</div>
					</div>
					<div class="carrier-item" style="background: #effaf4;" @click="pushWithQuery(4)">
						<div class="carrier-item-name">创业<br />商机</div>
						<div class="carrier-item-icon">
							<img style="width: 30px;" src="../assets/images/rdcy.png" />
						</div>
					</div>
					<div class="carrier-item" style="background: #f9edf7;" @click="pushWithQuery(3)">
						<div class="carrier-item-name">服务<br />配套</div>
						<div class="carrier-item-icon">
							<img style="width: 30px;" src="../assets/images/fwpt.png" />
						</div>
					</div>
				</div>
				<div class="carrier-box">
					<div class="carrier-item" style="background: #faeceb;" @click="pushWithQuery(9)">
						<div class="carrier-item-name">优质<br />地块</div>
						<div class="carrier-item-icon">
							<img style="width: 30px;" src="../assets/images/yzdk.png" />
						</div>
					</div>
					<div class="carrier-item" style="background: #eceefb;" @click="toUrl('projectSel')">
						<div class="carrier-item-name">重点<br />项目</div>
						<div class="carrier-item-icon">
							<img style="width: 30px;" src="../assets/images/zdxm.png" />
						</div>
					</div>
					<div class="carrier-item" style="background: #ffecd5;" @click="pushWithQuery(7)">
						<div class="carrier-item-name">办事<br />网点</div>
						<div class="carrier-item-icon">
							<img style="width: 30px;" src="../assets/images/bswd.png" />
						</div>
					</div>
				</div>
				<div class="carrier-box">
					<div class="carrier-item" style="background: #e2fcf9;" @click="toUrl('policyList')">
						<div class="carrier-item-name">惠企<br />政策</div>
						<div class="carrier-item-icon">
							<img style="width: 30px;" src="../assets/images/tzzc.png" />
						</div>
					</div>
					<div class="carrier-item" style="background: #fff5da;" @click="toArticleList(2)">
						<div class="carrier-item-name">人才<br />招聘</div>
						<div class="carrier-item-icon">
							<img style="width: 30px;" src="../assets/images/rczp.png" />
						</div>
					</div>
					<div class="carrier-item" style="background: #e2f2ff;" @click="toArticleList(3)">
						<div class="carrier-item-name">楼宇<br />招租</div>
						<div class="carrier-item-icon">
							<img style="width: 30px;" src="../assets/images/lyxm.png" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 尾部 -->
		<myFooter></myFooter>
		<!-- 侧边悬浮 -->
		<sideFloat></sideFloat>
		<!-- 底部菜单 -->
		<bottomMenu></bottomMenu>
	</div>

</template>
<script>
	import myFooter from '@/components/layouts/myFooter'
	import bottomMenu from '@/components/layouts/bottomMenu'
	import sideFloat from '@/components/layouts/sideFloat'
	import {
		useRouter
	} from 'vue-router'
	import {
		ref,
		defineComponent,
		reactive
	} from 'vue'
	import {
		ElMessage
	} from 'element-plus'
	import {
		Vue3SeamlessScroll
	} from 'vue3-seamless-scroll'
	import {
		getDynamicList
	} from '@/axios/api'
	export default defineComponent({
		components: {
			Vue3SeamlessScroll,
			myFooter,
			bottomMenu,
			sideFloat
		},
		setup() {

			// 视频播放器参数
			const videoOptions = reactive({
				width: "100%",
				height: "100%",
				color: "#409eff",
				control: true,
				title: "",
				src: "https://vod.changde.gov.cn/vod2/h5/cdzssp-1.mp4",
				poster: "https://vod.changde.gov.cn/vod2/h5/videopic.jpg",
				type: "video/mp4"
			});

			const datetime = reactive({
				nowTime: ''
			})
			//顶部时间
			function getTime() {
				var myDate = new Date();
				var myYear = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
				var myMonth = myDate.getMonth() + 1; //获取当前月份(0-11,0代表1月)
				var myToday = myDate.getDate(); //获取当前日(1-31)
				var myDay = myDate.getDay(); //获取当前星期X(0-6,0代表星期天)
				var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

				datetime.nowTime = myYear + '年' + fillZero(myMonth) + '月' + fillZero(myToday) + '日' +
					'&nbsp;' + week[myDay] + '&nbsp;';
			}
			// 格式处理 加小于10时前面加0
			function fillZero(str) {
				var realNum;
				if (str < 10) {
					realNum = '0' + str;
				} else {
					realNum = str;
				}
				return realNum;
			}
			//
			setInterval(getTime, 1000);


			let scrollWith = ref('');
			scrollWith = (window.innerWidth - 130) + 'px'; // 获取屏幕宽度并设置

			const dataList = ref('');
			//
			(function getData() {

				getDynamicList('/cdMapApi/api/park/dynamics/list', {

				}).then(function(res) {
					let {
						code,
						data,
						msg
					} = res.data;
					if (code == 200) {
						// 当前渲染数据列表
						dataList.value = data.slice(0, 10)
					} else {
						ElMessage({
							offset: 100,
							type: 'error',
							message: msg
						});
					}
				})
			})();

			const router = useRouter();
			sessionStorage.removeItem("iconUrl");
			// 地图跳转
			function pushWithQuery(menuId) {
				sessionStorage.setItem('curMeunId', menuId);
				router.push({
					name: 'mapView',
				});
			}
			// 文章列表
			function toArticleList(typeId) {
				router.push({
					name: 'articleList',
					query: {
						typeId: typeId
					}
				})
			}
			// 其他内容
			function toUrl(routerName) {
				router.push({
					name: routerName,
				})
			}
			// 招商动态内容
			function toDynamicDetail(dynamicId) {
				router.push({
					name: 'dynamicDetail',
					query: {
						dynamicId: dynamicId
					}
				})
			}

			return {
				datetime,
				getTime,
				fillZero,
				dataList,
				videoOptions,
				pushWithQuery,
				toArticleList,
				toUrl,
				toDynamicDetail,
				scrollWith
			}
		}
	})
</script>
<style lang="scss" scoped>
	.home-index {
		height: auto;
		min-height: 100vh;
		background: #fff url(../assets/images/home_bg.jpg) no-repeat center -150px;
		padding: 15px;

		.header {
			display: flex;
			justify-content: space-between;
			margin-bottom: 15px;
			align-items: center;
			color: #fff;

			.left {
				font-size: 22px;
				font-weight: bold;
			}

			.right {
				font-size: 16px;
			}
		}

		.main {
			.banner {
				width: 100%;
				margin-bottom: 15px;
				border-radius: 10px;
				overflow: hidden;

				video {
					width: 100%;
					border-radius: 10px;
				}
			}

			.notice {
				display: flex;
				align-items: center;
				background: #fff;
				margin: 10px auto;
				padding: 10px 0px 10px 10px;

				.icon {
					width: 45px;
					height: 33px;

					img {
						width: 45px;
					}
				}

				.list {
					padding-left: 10px;

					.scroll {
						height: 40px;
						overflow: hidden;

						.item {
							display: flex;
							justify-content: space-between;
							align-items: center;
							height: 40px;
							line-height: 40px;
							overflow: hidden;

							.title {
								width: calc(100% - 50px);
								height: 40px;
								line-height: 40px;
								white-space: nowrap;
								text-overflow: ellipsis;
								overflow: hidden;
							}

							.date {
								height: 40px;
								line-height: 40px;
							}
						}
					}
				}

				.more {
					width: 30px;
					height: 25px;
					text-align: center;

					img {
						width: 25px;
					}
				}

			}

			.links {
				width: 100%;

				a {
					display: block;

					img {
						width: 100%;
						border-radius: 10px;
					}
				}
			}

			.overview {
				background: #fff;
				border-radius: 10px;
				margin-bottom: 15px;
				text-align: center;
				padding: 10px;

				.btn-icon {
					text-align: center;
				}
			}

			.carrier {
				margin-top: 10px;

				.carrier-box {
					width: 100%;
					display: flex;
					justify-content: space-between;
					margin-bottom: 10px;

					.carrier-item {
						width: calc((100% - 20px)/3);
						height: 75px;
						border-radius: 10px;
						display: flex;
						justify-content: space-between;
						align-items: center;

						.carrier-item-name {
							width: calc(100% - 40px);
							text-align: center;
							margin-left: 5px;
						}

						.carrier-item-icon {
							width: 30px;
							height: 30px;
							margin-right: 15px;
						}
					}
				}
			}
		}
	}
</style>